import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "../context/AuthContext";
import { brand } from "../theme/tokens";

/**
 * Route guard.
 *
 *   <Route element={<RequireRole roles={["admin", "collector"]} />}>
 *     <Route path="/dashboard" element={<DashLayout />}>...</Route>
 *   </Route>
 *
 * or wrapping a single element:  <RequireRole roles={["admin"]}><Page/></RequireRole>
 *
 * - while auth is loading → centered spinner (never flash /login)
 * - no user → redirect to /login
 * - role not permitted → redirect to /forbidden
 */
const RequireRole = ({ roles = [], children }) => {
  const { user, role, loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: brand.purple,
        }}
      >
        <CircularProgress sx={{ color: brand.amber }} />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (roles.length > 0 && !roles.includes(role)) {
    return <Navigate to="/forbidden" replace />;
  }

  return children ? children : <Outlet />;
};

export default RequireRole;
